import { numericFormatter } from 'react-number-format';

import { type CurrencyType } from 'constants/Currencies';

export const formatCurrency = (cents: number, currency = 'usd', locale = 'en-US') => {
  const dollars = cents / 100;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(dollars);
};

/**
 * Simple version, takes whole amount, displays cents, if they exist
 *
 * formatMonetary(1234567, "USD") -> "$1,234,567"
 * formatMonetary(1234567.1, "USD") -> "$1,234,567.10"
 */
export const formatMonetary = (value: string | number, currencyValue: CurrencyType['value']) => {
  return Number(value).toLocaleString('en-US', {
    style: 'currency',
    currency: currencyValue ?? 'USD',
    minimumFractionDigits: Number.isInteger(Number(value)) ? 0 : 2,
    maximumFractionDigits: 2,
  });
};

export const formatNumber = (number?: number, fractionDigits = 2, isAlwaysNumberFloat = false) => {
  return number
    ? numericFormatter(number.toFixed(!isAlwaysNumberFloat && Number.isInteger(number) ? 0 : fractionDigits), {
        thousandSeparator: true,
      })
    : '';
};

export const formatNumberToShort = (number: number) =>
  number.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    notation: 'compact',
    compactDisplay: 'short',
  });

export const getNumberFromString = (str: string) => {
  const match = str?.match(/(-?\d+(\.\d+)?)/); // Matches numbers with optional decimal part
  return match ? parseInt(match[0], 10) : NaN;
};

export const getNumbersArray = (arr: string[]) => {
  return arr.map((item) => getNumberFromString(item)).filter((num) => !isNaN(num));
};
